import React from 'react';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { Account } from '@lgg/isomorphic/types/__generated__/graphql';
import {
  ConversationBanner,
  ConversationBannerIcon,
} from 'src/components/pages/conversations/components/contact-interactions/banners/shared';
import { useFormatDate } from 'src/hooks/use-format-date';

const ClosedConversationBannerContainer = styled(ConversationBanner)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.cosmo};
  height: max-content;
  justify-content: center;
  max-height: 44px;
  padding: 8px 15px;
`;

const StrongText = styled.span`
  font-family: ${({ theme }) => theme.font.medium};
`;

const BannerTitle = styled.span`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.font.regular};
  line-height: 14px;
  text-align: left;
`;

type ClosedConversationBannerProps = {
  closedAt: Date;
  closedBy: Account;
};

export const ClosedConversationBanner = ({
  closedAt,
  closedBy,
}: ClosedConversationBannerProps) => {
  const { formatSimpleDate, formatDate } = useFormatDate();

  return (
    <ClosedConversationBannerContainer data-lgg-id="closed-conversation-banner">
      <ConversationBannerIcon type="circularCheck" color="white" />
      <BannerTitle>
        <Trans
          i18nKey="conversations:conversationStatus.closed"
          values={{
            closedBy: closedBy.fullName,
            closedAt: `${formatSimpleDate(closedAt)}, ${formatDate(closedAt, 'hh:mma')}`,
          }}
          components={{ strong: <StrongText /> }}
        />
      </BannerTitle>
    </ClosedConversationBannerContainer>
  );
};
